import React, { useEffect } from 'react';
import { GoogleMap, useJsApiLoader, HeatmapLayer } from '@react-google-maps/api';
import { useTheme } from '@mui/material/styles';
import { Order } from '../../../../app/services/api/orderManagementClient';
import useCurrencyCodeConfiguration from '../../../../hooks/configurations/useCurrencyCodeConfiguration';
import { applyRoundAndFormat } from '../../../../utils';

interface SalesByMarketProps {
  orders: Order[];
}

const SalesByMarket = ({ orders }: SalesByMarketProps) => {
  const theme = useTheme();
  const { currencyCode, getCurrencyCodeConfiguration } = useCurrencyCodeConfiguration();
  
  useEffect(() => {
    getCurrencyCodeConfiguration();
  }, []);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAn3FgyVwPfbulsKlqDwOWTpwg2ChYe-yk',
    libraries: ['visualization'],
  });

  const heatmapData: { location: { lat: number, lng: number }, weight: number }[] = [
  ];

  // Group sales by supplierName (market)
  const marketTotals: { [market: string]: number } = {};
  orders.forEach(order => {
    marketTotals[order.supplierName] = (marketTotals[order.supplierName] || 0) + (order.totalCost || 0);
  });

  const mapContainerStyle = {
    width: '100%',
    height: '200px',
    color: theme.palette.text.primary,
    fontSize: theme.typography.textSM.fontSize,
  };

  const center = {
    lat: 39.8283,
    lng: -98.5795,
  };

  return (
    <div>
      {Object.entries(marketTotals).map(([market, total]) => (
        <div key={market}>{market}: {applyRoundAndFormat(total / 1000, currencyCode)}k</div>
      ))}
      {isLoaded ? (
        <GoogleMap mapContainerStyle={mapContainerStyle}
          center={center}
          zoom={4}
          options={{
            disableDefaultUI: true,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: false,
            fullscreenControl: true,
          }}>
          <HeatmapLayer
            data={heatmapData.map((h) => ({
              location: new window.google.maps.LatLng(h.location.lat, h.location.lng),
              weight: h.weight,
            }))}
          />
        </GoogleMap>
      ) : null}
    </div>
  );
};

export default SalesByMarket;